onComplete(function() {
	const isMobile = window.matchMedia("(max-width: 991px)").matches;
	const PAGE_SCROLL_THRESHOLD = isMobile ? 150 : 200;
	window.addEventListener('scroll', () => {
		const scroll = window.pageYOffset || document.documentElement.scrollTop;
		const navHeader = document.querySelectorAll('.nav-header');
		if (scroll >= PAGE_SCROLL_THRESHOLD) {
			navHeader.forEach(el => el.classList.add('scroll'));
		} else {
			navHeader.forEach(el => el.classList.remove('scroll'));
		}
	})
});